<template>
  <article>
    <v-container id="form-login" fluid class="pa-0">
      <v-layout row wrap align-center>
        <v-flex xs12 sm12 style="z-index: 2;">
          <div class="newLogin">
          <v-layout column align-center justify-center class="white--text">
            <span style="cursor: pointer" title="Motor Fiscal" @click="$router.push('/')">
              <img
                src="@/assets/images/logo_transparente/÷cone Negativo.png"
                alt="Logo motor"
                height="100"
                style="margin-left: 9px;"
              />
              <h1 class="white--text mb-4 display-1 text-xs-center" style="font-weight: 500;">
                <span style="color:#00a3a3; font-weight: 800;letter-spacing: 2px!important;">M</span>otor Fiscal
              </h1>
            </span>
          </v-layout>
          <v-slide-x-transition v-if="!forgotMenu">
            <article class="login"  @keydown.enter="logar()">
              <v-form v-model="valid" ref="form" id="formLogin" style="width: 60%;margin: 0 auto;">
                <v-text-field
                  class="email"
                  v-model="conta.email"
                  validate-on-blur
                  :rules="emailRules"
                  label="E-mail: (Login)"
                  type="text"
                  style="padding: 20px 0;color:white!important;"
                  dark
                  clearable
                  required
                  placeholder=" "
                  color="white"
                ></v-text-field>

               


                <v-text-field
                  v-model="conta.password"
                  :rules="passRules"
                  validate-on-blur
                  label="Senha:"
                  style="padding: 20px 0;color:white!important;"
                  :append-icon="showPass ? 'visibility_off' : 'visibility'"
                  :type="showPass ? 'text' : 'password'"
                  @click:append="showPass = !showPass"
                  
                  dark
                  placeholder=" "
                  clearable
                  required
                  color="white"
                ></v-text-field>
              </v-form>
              <div style="text-align:center;margin-top: -25px;">
              <a
                color="white"
                style="text-transform: none !important;color:white;text-decoration: underline;"
                @click="forgotMenu = !forgotMenu"
              >Esqueceu a senha?</a>
              </div>
              <!-- <v-layout row justify-center class="panel_btn_actions"> -->
                
                
                <v-btn color="success_custom" class="btnLogar" block @click="logar()">Entrar</v-btn>
                <div style="text-align:center;white-space:nowrap;">
                <span style="color:white;">Ainda não possui uma conta? <a
                  class="btnCadastrar"
                  style="color:white!important;font-weight: bold;text-decoration: underline;"
                  block
                  @click="$router.push('/cadastrar')"
                >Cadastrar</a></span>
                </div>
              <!-- </v-layout> -->
              
            </article>
          </v-slide-x-transition>
          <v-slide-x-transition v-else>
            <article class="forgot" @keydown.enter="recover()">
              
              <v-layout
                column
                align-center
                justify-center
                class="white--text"
                style="padding-top: 0!important;padding-left: 0; padding-right: 0;"
              >
                <h3>Recuperação de senha:</h3>
                <v-form
                  v-model="forgotForm"
                  @submit.prevent
                  ref="form"
                  id="formLogin"
                  style="width: 60%;margin: 0 auto;"
                >
                  <v-text-field
                    class="email"
                    v-model="forgotEmail.email"
                    validate-on-blur
                    :rules="emailRules"
                    label="E-mail da conta:"
                    type="text"
                    style="padding: 20px 0;color:white!important;"
                    dark
                    color="white"
                    clearable
                    placeholder=" "
                    required
                  ></v-text-field>
                </v-form>
              </v-layout>
              <v-layout row justify-center class="panel_btn_actions">

                <v-btn @click="forgotMenu = !forgotMenu">
                  Voltar
                </v-btn>

                <v-btn
                  color="warning_custom"
                  class="btnCadastrar"
                  @click.native="recover()"
                >Recuperar senha</v-btn>
              </v-layout>
            </article>
          </v-slide-x-transition>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog
      @keydown.esc="openDialog = false"
      v-model="openDialog"
      id="acesso-bloqueado-contato"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span>
            <strong>Acesso bloqueado</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="openDialog=false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <small>
                Sua conta está com o acesso bloqueado, entre em
                <strong>contato</strong>
                para mais informações:
                <div>
                  <strong>E-mail:</strong>contato@motorfiscal.com.br
                  <br />
                  <strong>Tel.:</strong> 11 4306 3036
                </div>
                <div>Agradecemos a compreensão!</div>
              </small>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="openDialog=false">Fechar</v-btn>
          <!-- <v-btn color="success"  @click.stop="newColumn()">Criar</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </article>
</template>
<script>
import GravatarService from "@/domain/gravatar/GravatarService.js";
import ContaService from "@/domain/conta/ContaService.js";
export default {
  props: ["alert"],
  components: {},
  data: () => ({
    valid: false,
    forgotMenu: false,
    conta: { email: "", password: "" },
    forgotForm: "",
    forgotEmail: { email: "" },
    message: "",
    openDialog: false,
    showPass: false,
    emailRules: [
      v => !!v || "Campo obrigatório",
      v =>
        /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) ||
        "Digite um e-mail válido"
    ],
    passRules: [v => !!v || "Campo obrigatório"],
    images: [
      '/static/img/bg1.jpg', 
      '/static/img/bg2.jpg', 
      '/static/img/bg3.jpg', 
      '/static/img/bg4.jpg',
      '/static/img/bg5.jpg',
      '/static/img/bg6.jpg',
      '/static/img/bg7.jpg',
    ],
  }),
  mounted() {
    this.changeBackgroundImage();
  },
  methods: {
    changeBackgroundImage() {
      document.querySelector('#content_login').style.backgroundImage = 'url(' + this.images[Math.floor(Math.random() * this.images.length)] + ')';
    },
    logar: function() {
      let body = JSON.stringify(this.conta);
      this.$http.post("usuarios/authenticate", body).then(
        success => {
          this.passRules = [];
          if (success.body.bloqueado) {
            this.openDialog = true;
          } else {
            this.redirectUser(success);
          }
        },
        failed => {
          this.message = "";
          this.alert.snackDanger();
          if (failed.status == 403) {
            this.alert.snack.text = "Credenciais inválidas";
          } else {
            this.alert.snack.text = "Algo não deu certo";
          }
          this.alert.snack.show = true;
        }
      );
    },
    redirectUser: async function(success) {
      this.$session.start();
      this.conta = success.body;
      this.service = new GravatarService(this.$http);
      await this.service
        .getGravatar(success.body.email)
        .then(success => {
          if (success) {
            if (success.hasOwnProperty("thumbnailUrl")) {
              this.conta["gravatarProfile"] = success;
            }
          }
        })
        .then(x => {
          this.$session.set("jwt", this.conta);
          this.$router.push("/DashBoard");
        });
    },
    recover: function() {
      if (this.$refs.form.validate()) {
        this.service = new ContaService(this.$http);
        this.service.recoverPassword(this.forgotEmail).then(
          success => {
            this.alert.snackDanger();
            this.alert.snack.text = success.body.message;
            if (success.ok) {
              this.alert.snackSuccess();
              this.resetRecover();
            }
            this.alert.snack.time = 5000;
            this.alert.snack.show = true;
          },
          failed => {
            this.alert.snackDanger();
            this.alert.snack.text =
              "Ocorreu algum erro ao recuperar a senha, por favor entre em contato" ||
              success.body.message;
            this.alert.snack.show = true;
          }
        );
      }
    },
    resetRecover: function() {
      this.forgotEmail.email = "";
      this.forgotMenu = false;
    }
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}
#form-login div {
  padding: 20px;
}
/* h1 {
  text-transform: uppercase;
} */
.pa-0 {
  z-index: 2;
}
.panel_btn_actions {
  width: 60%;
  margin: 0 auto;
  padding-top: 0;
  /* margin-top: -31px; */
}
/* .panel_btn_actions .btnCadastrar {
  margin-right: 50px;
} */
/* .btnCadastrar {
  margin-top: 5.5px!important;
  height: 36px!important;
} */
.btnCadastrar.primary_custom {
  color: white;
  border: thin solid black;
}
.btnCadastrar.warning_custom {
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(#435ac2),
    to(#4c65d6)
  );
  color: white;
  border: thin solid black;
  margin-top: 5.5px!important;
  height: 36px!important;
}
.btnLogar.success_custom {
  width: 40%;
  margin: auto;
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(teal),
    to(rgb(2, 173, 173))
  );
  color: white;
  border: thin solid black;
}
.panel_forgot span {
  cursor: pointer;
}
.panel_forgot span:hover {
  text-decoration: underline;
}
/* #000000cc; */
/* #00000061 */
.newLogin {
  background: #0000008c;
  border-radius: 10px;
  margin: auto;
  width: 40%;
  height: 90%;
  margin-top: 3%;
  padding: 20px 0!important;
}
@media(max-width: 1300px) {
  .newLogin {
    width: 45%;
  }
}
@media(max-width: 1100px) {
  .newLogin {
    width: 50%;
  }
}
@media(max-width: 1000px) {
  .newLogin {
    width: 55%;
  }
}
@media(max-width: 900px) {
  .newLogin {
    width: 60%;
  }
}
@media(max-width: 800px) {
  .newLogin {
    width: 70%;
  }
}
@media(max-width: 700px) {
  .newLogin {
    width: 80%;
  }
}
@media(max-width: 600px) {
  .newLogin {
    width: 90%;
  }
}
@media(max-width: 500px) {
  .newLogin {
    width: 100%;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/guestArea/login/Login.vue